"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const TESTIMONIALS = [{
  author: "CLIENTS NAME",
  quote: "Reviews Here",
  position: "Varsity Shortstop"
}, {
  author: "Robert K.",
  quote: "The mental game coaching is what sets CJ's Circle apart. My daughter has so much more confidence and composure under pressure now.",
  position: "Parent"
}, {
  author: "Sarah T.",
  quote: "The online training portal is a game changer. Being able to review drills and techniques at home has accelerated my development tenfold.",
  position: "Travel Ball Player"
}];
export default function VoicesFromOurCommunity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}